const calculatePositionSliderPosition = (slider) => {
  const minValue = slider.getAttribute('min') ? Number(slider.getAttribute('min')) : 0;
  const maxValue = slider.getAttribute('max') ? Number(slider.getAttribute('max')) : 100;
  const currentValue = slider.value;

  if (currentValue < minValue || currentValue > maxValue) return;

  const percentage = ((currentValue - minValue) / (maxValue - minValue)) * 100;

  return percentage.toFixed(2);

};

const setSliderPosition = (slider, cb) => {
  const currentValue = calculatePositionSliderPosition(slider);
  const valPercent = `${currentValue}%`;
  slider.style.setProperty('--valuePercent', valPercent);
  cb?.(slider.value);
};

export const rangeHandler = (parent, cb = null) => {
  const slider = parent.querySelector('[data-range-slider]');

  if (!slider) return;
  setSliderPosition(slider, cb);
  slider.addEventListener('input', () => setSliderPosition(slider, cb));
};

